module.exports = __webpack_public_path__ + "static/ndclondon18-1-571f3c2071e92d0d7772777b3ee0f940.jpeg";